var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_27590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 12.5H3.33464C2.89261 12.5 2.46868 12.3244 2.15612 12.0119C1.84356 11.6993 1.66797 11.2754 1.66797 10.8334V3.33335C1.66797 2.89133 1.84356 2.4674 2.15612 2.15484C2.46868 1.84228 2.89261 1.66669 3.33464 1.66669H10.8346C11.2767 1.66669 11.7006 1.84228 12.0131 2.15484C12.3257 2.4674 12.5013 2.89133 12.5013 3.33335V4.16669M9.16797 7.50002H16.668C17.5884 7.50002 18.3346 8.24621 18.3346 9.16669V16.6667C18.3346 17.5872 17.5884 18.3334 16.668 18.3334H9.16797C8.24749 18.3334 7.5013 17.5872 7.5013 16.6667V9.16669C7.5013 8.24621 8.24749 7.50002 9.16797 7.50002Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_27590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3afa33e2b2c4290f29e00b504df4aa20.svg";
export { ForwardRef as ReactComponent };